import ENV from "../env";

/**
 * Save customer's guess for the contest (public, no authentication required)
 * Used by visitors after they submit their initial form
 */
const saveGuessCustomerPublic = async (customerId, guess) => {
  const response = await fetch(
    `${ENV.firebaseApiUrl}/publicCustomer/guess-public/${customerId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        guess,
      }),
    }
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Save guess failed: " + (resData.error || resData.message));
  }

  return resData.success;
};

export default saveGuessCustomerPublic;
